export class FiltroListaDistribuzioneVO {
  nome: string;
  descrizione: string;
  nomeSettore: string[];
}
